const CompareInformation = () => import('@/views/immigrations/CompareInformation')
const MonthlyInformation = () => import('@/views/immigrations/MonthlyInformation')
const InformationRecentMonth = () => import('@/views/immigrations/InformationRecentMonth')
const Asean = () => import('@/views/immigrations/Asean')
// const EastAsia = () => import('@/views/immigrations/EastAsia')
// const Europe = () => import('@/views/immigrations/Europe')
// const America = () => import('@/views/immigrations/America')

// const Standard = () => import('@/views/immigrations/Standard')
// const StandardAllCountry = () => import('@/views/immigrations/StandardAllCountry')
// const AllCountry = () => import('@/views/immigrations/AllCountry')
// const StandardDaily = () => import('@/views/immigrations/StandardDaily')
const ImmigrationReport = () => import('@/views/immigrations/ImmigrationReport')

const mainWidget = [
  {
    title: 'เปรียบเทียบข้อมูลล่าสุด กับเป้าหมาย',
    path: '/admin/widget/:category/:widget_code(133)',
    component: CompareInformation
  },
  {
    title: 'ข้อมูลรายเดือนเปรียบเทียบ 2 ปี',
    path: '/admin/widget/:category/:widget_code(134)',
    component: MonthlyInformation
  },
  {
    title: 'ข้อมูลในเดือนล่าสุด',
    path: '/admin/widget/:category/:widget_code(135)',
    component: InformationRecentMonth
  },
  {
    title: 'ข้อมูลภูมิภาคอาเซียน เอเชียใต้ และแปซิฟิกใต้',
    path: '/admin/widget/:category/:widget_code(136)',
    component: Asean
  },
  {
    title: 'ข้อมูลภูมิภาคเอเชียตะวันออก',
    path: '/admin/widget/:category/:widget_code(137)',
    component: Asean
  },
  {
    title: 'ข้อมูลภูมิภาคยุโรป แอฟริกา และตะวันออกกลาง',
    path: '/admin/widget/:category/:widget_code(138)',
    component: Asean
  },
  {
    title: 'ข้อมูลภูมิภาคอเมริกา',
    path: '/admin/widget/:category/:widget_code(139)',
    component: Asean
  },
  {
    title: 'รายงานข้อมูลแบบตาราง',
    path: '/admin/widget/:category/:widget_code(140)',
    // component: Standard
    component: ImmigrationReport
  },
  // {
  //   title: 'ตารางมาตรฐาน 51 ประเทศ',
  //   path: '/admin/widget/:category/:widget_code(141)',
  //   component: StandardAllCountry
  // },
  // {
  //   title: 'ตารางทุกประเทศ',
  //   path: '/admin/widget/:category/:widget_code(142)',
  //   component: AllCountry
  // },
  // {
  //   title: 'ตารางมาตรฐาน(รายวัน)',
  //   path: '/admin/widget/:category/:widget_code(143)',
  //   component: StandardDaily
  // }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})